import React,{useEffect} from "react";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from '../../../constants/CustomDropdown';
import {getdepartmentData} from "../../../redux/actions/dataAction";
import {connect} from 'react-redux';

const SurveyDashboard = (props) => {
    useEffect(()=>{
        props.getdepartmentData()
      },[])

  return (
  <div className="customContainer">
      <CustomHeading title="Survey Dashboard"/>
      <div className="row">
          <div className="col-md-4">
           <CustomDropdown
            label="Year :"
            data={[{value:2019},{value:2020},,{value:2021},{value:2022},{value:2023}]}
            notDefaultOption
            defaultOption={"Select Year"}
            />
          </div>
          <div className="col-md-4">
          <CustomDropdown
            label="Department :"
            data={props?.department?.data?.map(d=>{
                return(
                    {value:d.name}
                )
            })}
            notDefaultOption
            defaultOption={"Select Department"}
            />
          </div>
      </div>
  </div>
  );
};
const mapActionWithProps = {
    getdepartmentData
  }
  
  const mapStateWithProps = (state)=>(
    {
      department:state.data.department
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(SurveyDashboard);
